const DEFAULT_MAX_AVATARS = 3;

export default function OverlappingAvatars({
    avatars,
    maxAvatars = DEFAULT_MAX_AVATARS
}: {
    avatars: string[],
    maxAvatars?: number
})
{
    return (
        <div
            className={Wind.style({
                position: "relative",
                display: "flex",
                alignItems: "items-center",
                paddingY: "py-0.5",
            }).class}
            style={{
                width: avatars.length > maxAvatars ? `${maxAvatars + 1}rem` : `${avatars.length + 1}rem`,
            }}
        >
            {avatars.slice(0, maxAvatars).map((avatar, index) => (
                <img
                    key={index}
                    src={avatar}
                    alt={`Avatar ${index + 1}`}
                    className={Wind.style({
                        width: "w-8",
                        height: "h-8",
                        borderRadius: "rounded-full",
                        borderWidth: "border-2",
                        borderColor: "border-[#FFEFD3]",
                        position: "absolute",
                        flex: "flex-[0_0_2rem]",
                    }).class}
                    style={{
                        left: index > 0 ? `${index * 1}rem` : "0rem",
                    }}
                />
            ))}
            {avatars.length > maxAvatars && (
                <span className="ml-8 text-sm text-gray-500">
                    +
                    {avatars.length - maxAvatars}
                </span>
            )}
        </div>
    );
}
